import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/design/design/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h4><a parentName="h4" {...{
        "href": "/guides/introduction"
      }}>{`Introduction`}</a></h4>
    <p>{`Get started with the principles of Primer, standards, and recommendations for designing Github.`}</p>
    <h4><a parentName="h4" {...{
        "href": "/guides/content"
      }}>{`Content`}</a></h4>
    <p>{`How to create interfaces that follow GitHub's content guidelines.`}</p>
    <h4><a parentName="h4" {...{
        "href": "/guides/zen"
      }}>{`The Zen of GitHub`}</a></h4>
    <p>{`How to create interfaces that follow GitHub's content guidelines.`}</p>
    <h4><a parentName="h4" {...{
        "href": "/guides/figma"
      }}>{`Figma`}</a></h4>
    <p>{`Getting started with Figma for GitHub.`}</p>
    <h4><a parentName="h4" {...{
        "href": "/guides/component-lifecycle"
      }}>{`Component lifecycle`}</a></h4>
    <p>{`Milestones that summarize the maturity lifecycle of UI components in Primer.`}</p>
    <h4><a parentName="h4" {...{
        "href": "/guides/accessibility"
      }}>{`Accessibility`}</a></h4>
    <p>{`How to create accessible interfaces for GitHub.`}</p>
    <h4><a parentName="h4" {...{
        "href": "/guides/contribute"
      }}>{`Contribute`}</a></h4>
    <p>{`How to contribute to Primer.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      